//
//
//
//
//

import xntk from './images/tk/tk1.jpg';
import $ from 'jquery';
 export default {
   data(){
     return {
       xntk,
     }
   },
   methods:{
     getcicun(){
       console.log(document.documentElement.clientWidth,document.documentElement.clientHeight,parseInt(document.documentElement.clientWidth/0.5633))

       if(parseInt(document.documentElement.clientWidth/0.5633) <document.documentElement.clientHeight){
         console.log(1)
         $('.xntk img').css({'width':'auto','height':document.documentElement.clientWidth/0.5633});
         $('.xntk img').css({'top':'50%','margin-top':(-document.documentElement.clientWidth/0.5633)/2 +'px','margin-left':'0px','left':'0%'});
       }else if(parseInt(document.documentElement.clientWidth/0.5633) >document.documentElement.clientHeight){
         console.log(2)
         $('.xntk img').css({'margin-top':'0px','top':'0%','width':(document.documentElement.clientHeight*0.5633)+"px",'left':'50%','margin-left':-(document.documentElement.clientHeight*0.5633)/2 +'px'});
         $('.xntk img').css('height',document.documentElement.clientHeight+'px');
       }else{
         console.log(3)
         $('.xntk img').css({'margin-right':'0px','right':'0%','margin-top':'0px','top':'0%','height':document.documentElement.clientWidth/0.5633});
       }
     }
   },
   mounted(){
     this.getcicun();

     let _this = this;
     $(window).resize(function() {
       _this.getcicun();
     })


     }
 }



// WEBPACK FOOTER //
// ./src/project/articleProject/xntk1.vue